/* eslint-disable */
export var Joky = {
  screen: {
    width: 0,
    height: 0,
    portrait: true,
  },
}

export const JokyGetScreen = () => {
  Joky.screen.width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  Joky.screen.height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  if (Joky.screen.width > Joky.screen.height) {
    Joky.screen.portrait = false;
  }else{
    Joky.screen.portrait = true;
  }

  var ww = window.innerWidth;
  if (ww > window.screen.width) {
    window.requestAnimationFrame(resize);
  } else {
    if (Joky.screen.portrait) {
      if (ww > 750) ww = 750;
      // 下面代码按照比例为100px = 1rem，此处一定要同pxToRem的转换比例
      document.documentElement.style.fontSize = (ww * 100) / 750 + "px";
    } else {
      if (ww > 1900) {
        ww = 1900;
      }
      document.documentElement.style.fontSize = (ww * 100) / 2400 + "px";
    }
  }
};




// WEBPACK FOOTER //
// ./src/joky.js